import React, { Suspense } from 'react';
import { LoadingPage } from 'components/LoadingPage/LoadingPage';

/**
 * Import thunks live here rather than inline in `App.tsx` so anything that warms a
 * module's chunk ahead of time shares the exact same chunk as the route rendering it.
 */
export const moduleImports = {
  public: () => import('modules/PublicModule/PublicModule'),
  compliance: () => import('modules/ComplianceModule/ComplianceModule'),
};

/** Suspense boundary for a lazily-loaded route element. */
export const Lazy: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense fallback={<LoadingPage />}>{children}</Suspense>
);
